import React, { useEffect, useState } from 'react';
import BASE_URL from '../../config';
import './embeddedApp.css';

// Shared by the OTA Service and Helpdesk sidebar tabs: both are separate
// apps on their own subdomains, embedded here as a full-height iframe so
// they feel like just another tab of this console (same idea as Device
// Management / Case Management), rather than opening in a new tab.
//
// To avoid making the admin log into that other app separately, this asks
// office's own backend for a short-lived, single-use handoff code (minted
// for whichever admin is currently logged in here) every time the tab is
// opened, then points the iframe at a URL that includes it. The other
// app's backend redeems the code server-side for a real session there --
// see mavis_backend's sso app and each target app's own /sso endpoint.
const EmbeddedApp = ({ audience, buildIframeSrc, title }) => {
  const [iframeSrc, setIframeSrc] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch(`${BASE_URL}/api/sso/issue-code/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('jwt_token')}`,
      },
      body: JSON.stringify({ audience }),
    })
      .then((res) => {
        if (!res.ok) throw new Error('Failed to start sign-in');
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        setIframeSrc(buildIframeSrc(data.code));
      })
      .catch(() => {
        if (!cancelled) setError(`Could not sign you into ${title}. Please try reopening this tab.`);
      });

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audience]);

  if (error) {
    return (
      <div className="embedded-app-status">
        <p className="embedded-app-error">{error}</p>
      </div>
    );
  }

  if (!iframeSrc) {
    return (
      <div className="embedded-app-status">
        <div className="aws-spinner"></div>
        <p>Signing you into {title}...</p>
      </div>
    );
  }

  return (
    <iframe
      src={iframeSrc}
      title={title}
      className="embedded-app-frame"
    />
  );
};

export default EmbeddedApp;
